<template>
<EntityReport entity="ReportSteps" />
</template>

<script>
export default {

}
</script>
